var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M254.142 175.858c7.81 7.81 7.81 20.474 0 28.284-7.21 7.21-18.554 7.764-26.4 1.664l-1.884-1.664L140 118.3l-85.858 85.842c-7.21 7.21-18.554 7.764-26.4 1.664l-1.884-1.664c-7.21-7.21-7.764-18.554-1.664-26.4l1.664-1.884 100-100c7.21-7.21 18.554-7.764 26.4-1.664l1.884 1.664z"
})));
export default SvgAngleUp;